import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from './Modal';

export default function ContactBox() {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);

    const content = useRef(null);

    useEffect(() => {
        function handleClickOutside(event) {
            if (content.current && !content.current.contains(event.target)) {
                setOpen(false);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [content]);

    return (
        <div className='content-box'>
            <span className='content-button' onClick={() => setOpen(true)}>
                <i className='fas fa-headset' />
            </span>
            <Modal visible={open}>
                <div className='modal-content text-center p10' ref={content}>
                    <span className='title-icon'>
                    <i className='fas fa-headset' />
                    </span>
                    <p className='title'>
                        {t('Ways to support you')}
                    </p>
                    {/* <a
                        href='whatsapp://send?phone=+989304058655'
                        className='btn btn-circle btn-whatsapp btn-block mt20 contact-btn'
                        //style={{ width: 'auto' }}
                    >
                        ارتباط از طریق واتس اپ
                        <i className='fab fa-whatsapp ml10' />
                    </a> */}
                    <a 
                        href='tel:02191065151' 
                        className='btn btn-circle btn-blue btn-block mt10 contact-btn'
                         //style={{ width: 'auto' }}
                         >
                        {t('Phone call contact')}
                        <i className='fas fa-phone ml10' />
                    </a>
                    <p className='description mt20'>
                        {t('We answer you as soon as possible')}
                    </p>
                </div>
            </Modal>
        </div>
    );

}